@if (facade.shouldDisplayNudgingNotification$ | async) {
  <web-design-system-notification
    class="d-block mb-3"
    color="red"
    size="mid"
    [headline]="'contract-confirmation.micar-contracts-nudging.headline' | transloco"
    [isDismissible]="false"
  >
    <div class="zero-text p-base-reg" [innerHTML]="'contract-confirmation.micar-contracts-nudging.text' | transloco"></div>
    <div class="d-flex justify-content-end mt-3">
      <web-design-system-button (click)="service.displayDialog()" size="small">
        {{ 'contract-confirmation.micar-contracts-nudging.btn' | transloco }}
      </web-design-system-button>
    </div>
  </web-design-system-notification>
}
